import React from 'react';
import styles from './SummaryCard.module.scss';

interface SummaryCardProps {
    title: string;
    value: React.ReactNode;
    subtitle?: React.ReactNode;
    className?: string;
}

const SummaryCard: React.FC<SummaryCardProps> = ({ title, value, subtitle, className, ...rest }) => {
    return (
        <div
            className={`${styles.container} ${className ?? ''}`}
            {...rest}
        >
            <div className={styles.title}>{title}</div>
            <div className={styles.value}>{value}</div>
            {subtitle ? <div className={styles.subtitle}>{subtitle}</div> : null}
        </div>
    );
};

export default SummaryCard;
